import { defineMessages } from "react-intl";

export const sidebarDrawerTriggerMessages = defineMessages({
  openNavigation: {
    id: "OkLJNT",
    defaultMessage: "Open navigation",
    description: "aria-label for collapsed main nav drawer trigger",
  },
});
